import API from '../api';

export const getFiscalCompanies = async ({ page = 1, perPage = 10, search = '', onlyUnconfigured = false, status = '' } = {}) => {
  const params = { page, perPage, search };
  if (onlyUnconfigured) params.onlyUnconfigured = 1;
  if (status) params.status = status; // 'active' | 'inactive'
  const res = await API.get('/fiscal/companies', { params });
  return res.data;
};

export const updateBillingConfig = async (id, data) => {
  const res = await API.put(`/fiscal/companies/${id}/billing`, data);
  return res.data;
};

export const getFiscalEligibility = async ({ from, to, search = '', onlyWithEligible = false } = {}) => {
  const params = { from, to, search };
  if (onlyWithEligible) params.onlyWithEligible = 1;
  const res = await API.get('/fiscal/eligibility', { params });
  return res.data;
};

export const downloadEligibilityCsv = async ({ from, to, search = '', onlyWithEligible = false } = {}) => {
  const params = { from, to, search };
  if (onlyWithEligible) params.onlyWithEligible = 1;
  const res = await API.get('/fiscal/eligibility/csv', { params, responseType: 'blob' });
  return res;
};

export const getEligibilityUsers = async ({ businessId, scope = 'single', from, to, page = 1, perPage = 20 } = {}) => {
  const res = await API.get('/fiscal/eligibility/users', { params: { businessId, scope, from, to, page, perPage } });
  return res.data;
};

export const downloadEligibilityUsersCsv = async ({ businessId, scope = 'single', from, to } = {}) => {
  const res = await API.get('/fiscal/eligibility/users/csv', {
    params: { businessId, scope, from, to },
    responseType: 'blob',
  });
  return res;
};

export const getServiceOrders = async ({ search = '', status = '', dateFrom = '', dateTo = '' } = {}) => {
  const params = {};
  if (search) params.search = search;
  if (status) params.status = status;
  if (dateFrom) params.dateFrom = dateFrom;
  if (dateTo) params.dateTo = dateTo;
  const res = await API.get('/fiscal/service-orders', { params });
  return res.data;
};
